/// <reference path="../../common/helpers/dialogutils.ts" />
/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class StockAllocatedItemsDialog extends _Ext.ItemEditorDialog<StockAllocatedItemsRow> {
        protected getFormKey() { return StockAllocatedItemsForm.formKey; }
        protected getLocalTextPrefix() { return StockAllocatedItemsRow.localTextPrefix; }
        protected getDeletePermission() { return StockAllocatedItemsRow.deletePermission; }
        protected getInsertPermission() { return StockAllocatedItemsRow.insertPermission; }
        protected getUpdatePermission() { return StockAllocatedItemsRow.updatePermission; }

        public form = new StockAllocatedItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        // #region Public Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public ItemMaster: any;
        public LotNo: any;

        // #endregion 

        
    }
}